import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import { useWorkflowEventQuery, useWorkflowQuery } from '@dashboard/generated/wp/platform';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';

type Props = {
  workflowRunId?: string | null;
};
export default function WorkflowLink({ workflowRunId }: Props) {
  const platformId = useCurrentPlatformId();
  const { data } = useWorkflowEventQuery({
    variables: { id: workflowRunId ?? '' },
    skip: !workflowRunId,
  });

  const workflowId = data?.WorkflowEvent.workflowId;

  const { data: workflowData } = useWorkflowQuery({
    variables: { id: workflowId ?? '' },
    skip: !workflowId,
  });

  const workflowName = workflowData?.Workflow.name;

  if (!workflowRunId) {
    return <>--</>;
  }

  function renderWorkflowLink() {
    if (!workflowId || !workflowName) {
      return null;
    }
    return (
      <Link href={`/o/${platformId}/workflows/${workflowId}`} underline="hover">
        {workflowName}
      </Link>
    );
  }
  return (
    <>
      {renderWorkflowLink()} (
      <Link href={`/o/${platformId}/workflow-runs/${workflowRunId}`} underline="hover">
        {workflowRunId}
      </Link>
      )
    </>
  );
}
